export enum CellDecorator {
    Image = 'image',
    CompanyIcon = 'companyIcon',
    Date = 'date',
    ExportPDF = 'exportPDF',
    Interest = 'interest',
    LabelDeviation = 'labelDeviation',
    Strikethrough = 'strikethrough',
    ProductProperty = 'productProperty',
    AcceptationGuide = 'acceptationGuide',
}

export enum RowDecorator {
    ScopeRow = 'scope-row',
}
